import { render, staticRenderFns } from "./AppBadge.vue?vue&type=template&id=79b27790"
import script from "./AppBadge.vue?vue&type=script&lang=js"
export * from "./AppBadge.vue?vue&type=script&lang=js"
import style0 from "./AppBadge.vue?vue&type=style&index=0&id=79b27790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports